import React from 'react'
import './contact.css'
import ContactForm from './ContactForm'
import ContactContent from './ContactContent'

const Contact = () => {
  return (
    <div id='contact' className='bg-body-secondary pt-4 p-2 mt-5 pb-5' style={{ overflowX: 'hidden' }}>
      <div className='contactHeader'>
        <h1 className='fw-bolder'>Get in <span className='fw-medium fst-italic text-primary'>Touch</span></h1>
      </div>
      <div className='row'>
        <div className="col-12 col-md-6">
          <ContactContent />
        </div>
        <div className="col-12 col-md-6">
          <ContactForm />
        </div>
      </div>
    </div>
  )
}

export default Contact